var map = {
	"./24hReception-min.png": 620,
	"./RoomService-min.png": 5035,
	"./about.png": 6440,
	"./aboutMob.png": 5649,
	"./brunch-min.png": 8233,
	"./brunchMob-min.png": 8572,
	"./callLogo.png": 7993,
	"./conferenceRoom-min.png": 1313,
	"./conferenceRoom2-min.png": 4601,
	"./conferenceRoomMob-min.png": 2778,
	"./conferenceRoomMob2-min.png": 3535,
	"./contactUs.png": 2150,
	"./contactUsMob.png": 3269,
	"./emailLogo.png": 8774,
	"./facebook.png": 6463,
	"./flower-min.png": 9609,
	"./gym-min.png": 6862,
	"./gymMob-min.png": 8294,
	"./gymlogo-min.png": 5773,
	"./instagram.png": 8935,
	"./intRes-min.png": 7861,
	"./laundry-min.png": 9522,
	"./locationLogo.png": 8625,
	"./nayaki-min.png": 9970,
	"./nayaki2-min.png": 5480,
	"./nayakiMob-min.png": 6314,
	"./nayakiMob2-min.png": 1108,
	"./pub-min.png": 603,
	"./royo-min.png": 9382,
	"./royo2-min.png": 1524,
	"./royoMob-min.png": 9715,
	"./royoMob2-min.png": 6033,
	"./slider1-min.png": 3602,
	"./slider2-min.png": 4110,
	"./slider3-min.png": 5354,
	"./slider4-min.png": 5054,
	"./slider5-min.png": 6140,
	"./slider6-min.png": 3504,
	"./slider7-min.png": 2911,
	"./slider8-min.png": 6917,
	"./swim-min.png": 6018,
	"./swimMob-min.png": 3333,
	"./swimlogo-min.png": 4242,
	"./wifi-min.png": 2043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;